import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Button } from '@openx/components-core/lib/Button/Button.tsx';
import type { ReactNode } from 'react';

type TermsAlertProps = {
  severity: 'info' | 'warning';
  dataTest: string;
  children: ReactNode;
};

const TermsAlert = ({ severity, dataTest, children }: TermsAlertProps) => (
  <Alert
    severity={severity}
    data-test={dataTest}
    variant="filled"
    sx={{
      bgcolor: 'background.paper',
      color: `${severity}.main`,
      lineHeight: '18px',
      margin: theme => `${theme.spacing(2)} 0`,
      padding: 0,
    }}
  >
    <Typography
      component="span"
      sx={{
        alignItems: 'center',
        color: `${severity}.dark`,
        display: 'flex',
        height: '100%',
        lineHeight: '18px',
      }}
    >
      {children}
    </Typography>
  </Alert>
);

export const Content = () => {
  return (
    <>
      <Typography
        variant="h2"
        data-test="title"
        sx={{
          mb: 4,
        }}
      >
        OpenX Terms of Service
      </Typography>
      <TermsAlert severity="info" dataTest="info-message">
        We've updated our Terms of Service to cover AI features and AI agents connected through the OpenX MCP Server,
        and make a few other clarifying changes. Please review and accept to continue. For more information on the OpenX
        MCP server, reach out to your account manager.
      </TermsAlert>
      <TermsAlert severity="warning" dataTest="alert-message">
        OpenXSelect Terms of Service have been updated and are effective as of October 30, 2026.
      </TermsAlert>
      <iframe
        title="terms&conditions"
        src="/terms_and_conditions.pdf"
        width="100%"
        height="500px"
        data-test="iframe-pdf"
      />
      <Box
        sx={{
          mt: 2,
        }}
      >
        <Link
          href="/terms_and_conditions.pdf"
          target="_blank"
          rel="noopener noreferrer"
          download="OpenX Terms&Conditions"
        >
          <Button data-test="download-pdf" size="small">
            Download as PDF
          </Button>
        </Link>
      </Box>
    </>
  );
};
